import { obtenerTurnosDisponibles } from "./busquedaTurnosApi";
import clienteHttp from "./ClienteHttps";
//import axios from 'axios';
//const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

//axios.defaults.withCredentials = true;

function limpiarFiltros(filtros) {
    const limpios = {};

    for (const clave in filtros) {

        if (filtros[clave] !== "") {

            limpios[clave] = filtros[clave];
        }

    }

    return limpios;
}

export async function buscarTurnos(usuarioId, filtros) {
    const filtrosLimpios = limpiarFiltros(filtros);

    if (!filtrosLimpios.limite) {
        filtrosLimpios.limite = 50;
    }

    return await obtenerTurnosDisponibles(usuarioId, filtrosLimpios);
}

export async function obtenerSedes() {
    try {
        const response = await clienteHttp.get("/turnos/sedes");
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function obtenerPracticas() {
    try {
        const response = await clienteHttp.get("/turnos/practicas");
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
